export default "__VITE_ASSET__8b9d4a7c__"